/* src/app/builder-screen-beta/event-scripting/expert-mode.component.scss */
.expert-mode-container {
  padding: 16px;
}
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #d9d9d9;
}
.mode-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #262626;
}
.mode-title nz-icon {
  font-size: 18px;
  color: #fa8c16;
}
.code-editor-section {
  margin-bottom: 16px;
}
.code-textarea {
  font-family:
    "Consolas",
    "Monaco",
    "Courier New",
    monospace;
  font-size: 13px;
  line-height: 1.6;
  background-color: #1e1e1e;
  color: #d4d4d4;
  border: 1px solid #3c3c3c;
  border-radius: 4px;
  padding: 12px;
}
.code-textarea::placeholder {
  color: #6a737d;
}
.code-textarea:focus {
  border-color: #fa8c16;
  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);
}
.validation-section {
  margin-bottom: 16px;
}
.validation-alert {
  margin-bottom: 8px;
}
.validation-alert:last-child {
  margin-bottom: 0;
}
.api-reference-section {
  margin-bottom: 16px;
}
.api-content h4 {
  margin-top: 16px;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #262626;
}
.api-content h4:first-child {
  margin-top: 0;
}
.api-content ul {
  margin: 0 0 12px 0;
  padding-left: 20px;
}
.api-content ul li {
  margin-bottom: 6px;
  font-size: 13px;
  color: #595959;
}
.api-content ul li code {
  background-color: #f5f5f5;
  padding: 2px 6px;
  border-radius: 3px;
  font-family:
    "Consolas",
    "Monaco",
    monospace;
  font-size: 12px;
  color: #d63384;
}
.examples-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.example-card .example-code {
  margin: 0;
  padding: 12px;
  background-color: #f5f5f5;
  border-radius: 4px;
  font-family:
    "Consolas",
    "Monaco",
    monospace;
  font-size: 12px;
  overflow-x: auto;
}
.monaco-note {
  margin-top: 16px;
}
/*# sourceMappingURL=expert-mode.component.css.map */
